__turbopack_context__.v({
  "alert": "TempMessage-module-scss-module__1E6iSG__alert",
  "box": "TempMessage-module-scss-module__1E6iSG__box",
});
